import {Component} from '@angular/core';
import {RegistrationService} from "../../../services/registration.service";
import {Subscription} from "rxjs";
import {ModalService} from "../../../services/modal.service";

@Component({
  selector: 'app-reg-modal',
  templateUrl: './reg-modal.component.html',
  styleUrls: ['./reg-modal.component.scss']
})
export class RegModalComponent {

  currentStep = 1;
  stepSubs: Subscription;

  constructor(
    private regService: RegistrationService,
    private modalService: ModalService
  ) {
    this.stepSubs = this.regService.regStep.subscribe(step =>{
      this.currentStep = step;
      if (this.currentStep === 5){
        //means that registration is done
        this.onCloseRegModal();
        this.currentStep = 1;
      }
    })
  }


  onCloseRegModal(){
    //when we click on close button, we loose filled in data - except from first step(that's stored in the form)
    this.regService.resetRegSession();
    this.modalService.close('signUpModal')
  }

  openLoginModal(){
    this.onCloseRegModal();
    this.modalService.open('signInModal');
  }

  ngOnDestroy(){
    this.stepSubs?.unsubscribe();
  }

}
